import React, { createContext, useContext, useState, ReactNode } from 'react';

interface FontContextType {
  fontRefreshTrigger: number;
  refreshFonts: () => void;
}

const FontContext = createContext<FontContextType | undefined>(undefined);

export function FontProvider({ children }: { children: ReactNode }) {
  const [fontRefreshTrigger, setFontRefreshTrigger] = useState(0);

  const refreshFonts = () => {
    console.log('FontContext: Refreshing fonts...');
    setFontRefreshTrigger(prev => prev + 1);
  };

  return (
    <FontContext.Provider value={{ fontRefreshTrigger, refreshFonts }}>
      {children}
    </FontContext.Provider>
  );
}

export function useFonts() {
  const context = useContext(FontContext);
  if (context === undefined) {
    throw new Error('useFonts must be used within a FontProvider');
  }
  return context;
}